<template>
    <div class="search-element" @click="modalControl">
        <div class="search-element__left">
            <i class="pi pi-search search-element__icon"></i>
            <span class="search-element__text">
                {{ t('global.search') }}
            </span>
        </div>
        <span class="system-hotkey" v-if="userSystem == 'mac'">⌘/K</span>
        <span class="system-hotkey" v-else>Ctrl/K</span>
    </div>
    <Dialog v-model:visible="searchModalState" modal :dismissableMask="true" :closable="false" pt:header:class="!hidden" pt:content:class="!p-7" class="custom-dialog">
        <SearchModalContent :modalState="searchModalState" />
    </Dialog>
</template>

<script setup>
import { ref, computed, onMounted } from 'vue';
import SearchModalContent from './SearchModalContent.vue';
import { useI18n } from 'vue-i18n';

const { t } = useI18n({ useScope: 'global' });

const searchModalState = ref(false);

const initSearchHotKey = () => {
    // document.addEventListener('keydown', (e) => {
    //     if (['k', 'K'].includes(e.key)) {
    //         if (!searchModalState.value) {
    //             if (userSystem.value == 'mac') {
    //                 if (e.metaKey) {
    //                     e.preventDefault();
    //                     searchModalState.value = !searchModalState.value;
    //                 }
    //             } else {
    //                 if (e.ctrlKey) {
    //                     e.preventDefault();
    //                     searchModalState.value = !searchModalState.value;
    //                 }
    //             }
    //         }
    //     }
    // });
};

const modalControl = () => {
    searchModalState.value = !searchModalState.value;
};

const userSystem = computed(() => {
    const userAgent = navigator.userAgent.toLowerCase();

    return userAgent.includes('mac') ? 'mac' : 'win';
});

onMounted(() => {
    initSearchHotKey();
});
</script>

<style>
.search-element {
    @apply w-[160px] flex items-center justify-between rounded-xl bg-[#1C1C1C07] py-1 px-2 cursor-pointer dark:bg-[#323232];
}

.search-element * {
    @apply text-[#1C1C1C20] dark:text-[#5b5b5b];
}

.search-element__left {
    @apply flex items-center gap-x-2;
}

.search-element__text {
    @apply select-none;
}

.search-element__icon {
    @apply dark:text-[--main-white];
}

.custom-dialog {
    @apply w-full max-w-2xl;
}
</style>
